<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide15',
  data() {
    return {
		mutationObserver: null,
      parallax: [
        {
          start: 15000,
          end: 15200,
          fromStyle: { opacity: 0 },
          toStyle: { opacity: 1 },
          easing: 'linear'
        },
        {
          start: 16000,
          end: 16500,
          fromStyle: { transform: 'translateY(0px) rotate(10deg)' },
          toStyle: { transform: 'translateY(1600px) rotate(0deg)' },
          easing: 'linear'
        },
      ]
    };
  },
  mounted() {
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/8.jpg',
          url: 'https://heller.brandeis.edu/iere/pdfs/racial-wealth-equity/racial-wealth-gap/roots-widening-racial-wealth-gap.pdf',
          link_title: {
			'en': 'The Roots of the Widening Racial Wealth Gap',
			'es': 'Las raíces de la creciente brecha de riqueza racial'
		  }
        },
      ],
      text: {
		'en': '"Homes are the largest investment that most American families make and by far the biggest item in their wealth portfolio. Homeownership is an even greater part of wealth composition for Black families, amounting to 53 percent of wealth for Blacks and 39 percent for whites. Yet...redlining, discriminatory mortgage-lending practices, lack of access to credit, and lower incomes have blocked the homeownership path for African-Americans."<br /><b>From: The Roots of the Widening Racial Wealth Gap: Explaining the Black-White Economic Divide by Thomas Shapiro,Tatjana Meschede, Sam Osoro, Institute on Assests and Social Policy</b>',
		'es': '"Las casas son la inversión más grande que hacen la mayoría de las familias estadounidenses y, con mucho, el artículo más grande en su cartera de riqueza. La propiedad de vivienda es una parte aún mayor de la composición de la riqueza de las familias negras, que asciende al 53 por ciento de la riqueza para los negros y el 39 por ciento para los blancos. Sin embargo, ...las prácticas discriminatorias de préstamos hipotecarios, la falta de acceso al crédito y los ingresos más bajos han bloqueado el camino de la propiedad de vivienda para los afroamericanos".<br /><b>De: Las raíces de la brecha de riqueza racial cada vez mayor: explicación la brecha económica entre blancos y negros por Thomas Shapiro, Tatjana Meschede, Sam Osoro, Institute on Assets and Social Policy</b>'
	  }
    };

    const text = {
		'en': 'While millions of Americans lost their homes during the foreclosure crisis, the consequences for BIPOC families were particularly dire, including the loss of a pathway to build generational wealth.',
		'es': 'Si bien millones de estadounidenses perdieron sus hogares durante la crisis de las ejecuciones hipotecarias, las consecuencias para las familias BIPOC fueron particularmente nefastas, incluida la pérdida de un camino para generar riqueza generacional.'
	};
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.opacity == '1') {
          this.$evidence.value = JSON.stringify(evidence);
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slide15'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/15_EvictionNotice.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 490px;
    height: 490px;
    left: -290px;
    top: calc(50% - 225px);
    transition: 0.3s;
    z-index: 4;
    transform: rotate(10deg);
    @media(max-width:600px) {
      width: 220px;
      left: -130px;
      top: calc(50% - 250px);
    }
}
</style>
